import {
  BOOL,
  INT,
  FLOAT,
  DATETIME,
  DATE,
  STRING,
  UUID,
  JSON,
  OTHER,
} from './ColumnType';
import { POSTGRES, REDSHIFT, BIGQUERY, SNOWFLAKE } from './enums/EnumDbType';

class AggregateOperation {
  constructor(readonly _name: string, readonly _advanced: boolean = false) {}

  static all(dbType: string) {
    const results = [
      // this list must match EnumAggregateOp
      new AggregateOperation('sum'),
      new AggregateOperation('avg'),
      new AggregateOperation('max'),
      new AggregateOperation('min'),
      new AggregateOperation('count', true),
      new AggregateOperation('array', true),
    ];
    if (
      dbType === POSTGRES ||
      dbType === REDSHIFT ||
      dbType === BIGQUERY ||
      dbType === SNOWFLAKE
    ) {
      results.push(new AggregateOperation('median'));
    }
    return results;
  }

  name() {
    return this._name;
  }

  isAdvanced() {
    return this._advanced;
  }

  supportedTypes() {
    switch (this.name()) {
      case 'sum':
      case 'avg':
      case 'median':
        return [INT, FLOAT];
      case 'max':
      case 'min':
        return [INT, FLOAT, DATETIME, DATE];
      case 'count':
      case 'array':
        return [BOOL, INT, FLOAT, DATETIME, DATE, STRING, UUID, JSON, OTHER];
    }
    throw new Error(`Unexpected name:${this.name()}`);
  }

  longName() {
    switch (this.name()) {
      case 'count':
        return 'count unique values of ...';
      default:
        return `${this.name()} of ...`;
    }
  }
}

export default AggregateOperation;

export const COUNT_UNIQUE = new AggregateOperation('count', true);
